export const IGNORED_MESSAGES: (RegExp | string)[] = [
  /signal is aborted without reason/, // https://app.rollbar.com/a/yieldbird/fix/item/yieldbird-platform/720#detail
  /user aborted a request/, // https://app.rollbar.com/a/yieldbird/fix/item/yieldbird-platform/712#detail
]
